// extracted by mini-css-extract-plugin
module.exports = {"img":"About_img__qBRyo","textimg":"About_textimg__3XjTs","imgcontainer":"About_imgcontainer__KGYoj","imgtextcentered":"About_imgtextcentered__3s7Ec"};